import Vue from "vue"

export const mutations = {
  userData: (state, payload) => {
    Vue.set(state, "userData", { ...state.userData, ...payload })
  },
  setTinderBooks: (state, bookList) => {
    Vue.set(state, "tinderBooks", bookList)
  }
}
